import React from 'react'

export const FORM_PUBLIC_BASE = 'https://prosperitymentors.net/forms'

export const FORM_TYPE_LABELS = {
  form: 'Form',
  survey: 'Survey',
  quiz: 'Quiz'
}

export const FORM_STATUS_LABELS = {
  draft: 'Draft',
  active: 'Active',
  closed: 'Closed'
}

export const QUESTION_TYPE_LABELS = {
  multiple_choice: 'Multiple choice',
  short_text: 'Short text',
  rating: 'Rating',
  yes_no: 'Yes / No'
}

export const TypeBadge = ({ type }) => {
  const styles = {
    form: 'bg-blue-100 text-blue-800',
    survey: 'bg-violet-100 text-violet-800',
    quiz: 'bg-amber-100 text-amber-800'
  }
  return (
    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${styles[type] || 'bg-slate-100 text-slate-700'}`}>
      {FORM_TYPE_LABELS[type] || type}
    </span>
  )
}

export const StatusBadge = ({ status }) => {
  const styles = {
    draft: 'bg-slate-100 text-slate-700',
    active: 'bg-emerald-100 text-emerald-800',
    closed: 'bg-red-100 text-red-800'
  }
  return (
    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${styles[status] || 'bg-slate-100 text-slate-700'}`}>
      {FORM_STATUS_LABELS[status] || status}
    </span>
  )
}

export const LanguageBadge = ({ language }) => (
  <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-700 uppercase">
    {language === 'en' ? 'EN' : 'ES'}
  </span>
)

export const getFormPublicUrl = (slug, customDomain) => {
  const path = `/forms/${slug}`
  if (customDomain && String(customDomain).trim()) {
    const host = String(customDomain).trim().replace(/^https?:\/\//, '').replace(/\/$/, '')
    return `https://${host}${path}`
  }
  return `${FORM_PUBLIC_BASE}/${slug}`
}

export const questionDisplayText = (question, language = 'es') => {
  if (!question) return ''
  if (language === 'en') {
    return question.question_text_en || question.question_text_es || ''
  }
  return question.question_text_es || question.question_text_en || ''
}

export const optionDisplayText = (option, language = 'es') => {
  if (!option) return ''
  if (language === 'en') {
    return option.option_text_en || option.option_text_es || ''
  }
  return option.option_text_es || option.option_text_en || ''
}
